export default __webpack_public_path__ + "static/logo-9-5cd2819f7ac2188ff2ad164d161e4667.jpeg";